module.exports = __webpack_public_path__ + "static/bg-pattern-6045dbdea0e99ef462e07d3172dcb108.jpg";